import React from "react";
import { Link } from "react-router-dom"
import Markdown  from "react-markdown";

const PortfolioProject = (props) => {

    const slugify = (str) => {
        return str
        .toLowerCase()
        .trim()
        .replace(/[\s\W-]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    return <article>
        <p className="info">{ props.location }</p>
        <h2>{ props.title }</h2>
        <p className="date">{ props.date }</p>
        
        <section className="content">
            <Markdown>{ props.description }</Markdown>
        </section>
        <section className="services">
            <h3>Services:</h3>
            <ul>
                {
                    props.services.map((item, index) => {
                        if (typeof item === "string") { 
                            return <li key={index}>{ item }</li> 
                        } 
                        // else if (!item.page_link) {
                        //     return <li key={index}>{ item.name }</li> 
                        // }
                        return <li key={index}><Link to={ `../services/${slugify(item.category)}` }>{ item.name }</Link></li>
                    })
                }
            </ul>
        </section>
    </article>
}

PortfolioProject.defaultProps = {
    title: "Catskills Cabin",
    location: "Monticello, New York",
    date: "May 2021 – August 2022",
    services: [
        "Construction Management",
        "Permit Expediting",
        "Preventative Maintenance"
    ]
};

export default PortfolioProject